module.exports = __webpack_public_path__ + "assets/img/Sustainable_002.d3b17869.svg";